import clsx from 'clsx';
import React from 'react';

interface PillProps {
  className?: string;
  href?: string;
  icon?: string;
  onClick?: () => void;
  onClickCapture?: () => void;
  text: string;
}

export default function Pill({ className, text, icon, href, onClick, onClickCapture }: PillProps) {
  const pillJSX = (
    <>
      <span className="pill-text">{text}</span>
      {icon && <img src={icon} className="link-icon" />}
    </>
  );

  return href || onClick ? (
    <a
      className={clsx('Pill is-link', className)}
      href={href}
      onClick={onClick}
      onClickCapture={onClickCapture}
    >
      {pillJSX}
    </a>
  ) : (
    <span className={clsx('Pill', className)}>{pillJSX}</span>
  );
}
